<template>
  <section class="success-stories">
    <div class="success-stories__content">
      <h1 class="success-stories__title">Real workflows.<br>Real results.</h1>
      <p class="success-stories__subtitle">
        See how designers at every level use Site Palette to capture accurate color palettes from the web — without changing how they work.
      </p>
      <div class="success-stories__cards">
        <SuccessStoryCard
          v-for="story in successStories"
          :key="story.slug"
          :story="story"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { successStories } from '@/data/successStories';
import SuccessStoryCard from './SuccessStoryCard.vue';

export default {
  components: {
    SuccessStoryCard,
  },
  setup() {
    return { successStories };
  },
};
</script>

<style scoped>
.success-stories {
  background-color: #f5f8fa;
  width: 100%;
  padding: 20px 20px 80px;
  display: flex;
  justify-content: center;
}

.success-stories__content {
  width: 100%;
  max-width: 1224px;
}

.success-stories__title {
  font-weight: 600;
  font-size: 60px;
  line-height: 72px;
  letter-spacing: -1.2px;
  color: #17191d;
  max-width: 720px;
  margin: 48px auto 24px;
  text-align: center;
}

.success-stories__subtitle {
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  color: #17191d;
  max-width: 720px;
  margin: 0 auto 48px;
  text-align: center;
}

.success-stories__cards {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 24px;
  min-height: 294px;
}

@media screen and (max-width: 768px) {
  .success-stories {
    padding: 15px 16px 60px;
  }

  .success-stories__title {
    font-size: 48px;
    line-height: 50px;
    letter-spacing: -0.96px;
    margin-top: 60px;
  }

  .success-stories__cards {
    flex-direction: column;
    flex-wrap: nowrap;
  }
}
</style>
